import { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { DTOQualityUserBadge } from 'src/apis/dto/DTOQualityUserBadge';
import BadgeImageBase from 'src/components/QualityUserBadge/BadgeImage';
import QualityUserBadgeModal from 'src/components/QualityUserBadgeModal';
import { showModalAtom } from 'src/stores/modal/atoms';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { ModalType } from 'src/types/Modal';
import { pushEvent } from 'src/utils/event-gateway';
const BadgeCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
`;
const BadgeButton = styled.button`
  ${BadgeCss};
  cursor: pointer;
`;
const BadgeDiv = styled.div`
  ${BadgeCss};
`;
const BadgeImage = styled(BadgeImageBase)`
  width: 100%;
  height: 100%;
`;
interface Props {
  qualityUserBadge: DTOQualityUserBadge;
  isMine: boolean;
  showModalOnClick: boolean;
  showFallbackImage?: boolean;
  className?: string;
}
const QualityUserBadge: FC<Props> = ({
  qualityUserBadge,
  isMine,
  showModalOnClick,
  showFallbackImage = false,
  className
}) => {
  const showModal = useSetAtom(showModalAtom);
  const onClick = () => {
    pushEvent({
      eventType: EVENT_TYPE.LOG,
      eventName: isMine ? EVENT_NAME.MY_PROFILE__CLICK_AZAR_BADGE : EVENT_NAME.PROFILE__CLICK_AZAR_BADGE,
      eventParams: {
        action_category: 'click',
        tab: 'anywhere',
        page: isMine ? 'my_profile' : 'profile',
        target: 'azar_badge',
        badge_status: qualityUserBadge.state
      }
    });
    showModal({
      key: ModalType.QUALITY_USER_BADGE,
      component: () => <QualityUserBadgeModal qualityUserBadge={qualityUserBadge} isMine={isMine} />
    });
  };
  const badgeImage = <BadgeImage src={qualityUserBadge.badgeImageUrl} showFallback={showFallbackImage} />;
  if (showModalOnClick) {
    return <BadgeButton className={className} onClick={onClick}>
        {badgeImage}
      </BadgeButton>;
  }
  return <BadgeDiv className={className} data-sentry-element="BadgeDiv" data-sentry-component="QualityUserBadge" data-sentry-source-file="index.tsx">{badgeImage}</BadgeDiv>;
};
export default QualityUserBadge;